module.exports = __webpack_public_path__ + "img/logo.d647601c.png";